import { Selector } from '@ngxs/store';
import { ConnectionsState } from './connections.state';
import { ConnectionsStateModel, FacebookPage } from './connections-state.model';

export class ConnectionsSelectors {
  @Selector([ConnectionsState])
  static pendingStatus(state: ConnectionsStateModel): boolean {
    return state.connectionPendingAPIStatus;
  }

  @Selector([ConnectionsState])
  static botProviders(state: ConnectionsStateModel): any[] {
    return state.providers;
  }

  @Selector([ConnectionsState])
  static facebookConnection(state: ConnectionsStateModel): any {
    return state.facebookConnection;
  }

  @Selector([ConnectionsState])
  static facebookPages(state: ConnectionsStateModel): FacebookPage[] {
    return state.facebookPages;
  }

  @Selector([ConnectionsState])
  static facebookAuthStatus(state: ConnectionsStateModel): string {
    return state.facebookAuthStatus;
  }
}
